// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionCard_section__AIIja"};